import * as React from 'react';
import PropTypes from 'prop-types';

import { Button, Input } from 'antd';

import s from './style/Roles.pcss';
import Loader from '../../../../shared/components/Loader/Loader';


export default class RoleSelector extends React.Component {
  static propTypes = {
    role: PropTypes.shape(),
    onEditRole: PropTypes.func.isRequired,
  };

  static defaultProps = {
    role: {},
  };

  state = {
    value: this.props.role.id ? this.props.role.name : '',
    saving: false,
  };

  componentWillReceiveProps(nextProps) {
    if (this.props.role.name !== nextProps.role.name) {
      this.setState({ value: nextProps.role.id ? nextProps.role.name : '' });
    }
  }

  onEditRole = () => {
    this.setState({ saving: true }, () => {
      this.props.onEditRole(this.state.value).then(() => {
        this.setState({
          value: this.props.role.id ? this.props.role.name : '',
          saving: false,
        });
      });
    });
  };

  changeValue = e => this.setState({ value: e.target.value });

  render() {
    const { saving } = this.state;
    return (
      <div className={s.overlayContainer}>
        <div className={s.addHeader}>
          <div className={s.addHeaderLabel}>
            {this.props.role.id ? this.props.role.name : 'Новая роль'}
          </div>
          <Button
            type="primary"
            className={s.createBtn}
            disabled={!this.state.value.trim() || saving}
            onClick={this.onEditRole}
          >
            {this.props.role.id ? 'Редактировать' : 'Добавить'}
          </Button>
        </div>
        {!saving &&
          <div className={s.inputContainer}>
            <div className={s.inputLabel}>Название роли</div>
            <Input onChange={this.changeValue} value={this.state.value} />
          </div>
        }
        {saving &&
          <div className={s.inputContainer}>
            <Loader fullScreen={false} size={40} />
          </div>
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Root/pages/Roles/Sidebar/RoleSelector.js